/**
 * Набор иконок в духе Linear: сетка 16px, обводка 1.5px, скруглённые концы,
 * без заливки.
 *
 * Почему свой набор, а не библиотека: Linear узнаётся в том числе тонкостью
 * штриха и одинаковой оптической плотностью иконок. Любой готовый набор
 * (Font Awesome из прототипов — в первую очередь) тянет свою весовую логику,
 * и строка с иконкой перестаёт выглядеть ровно. Здесь двадцать с небольшим
 * фигур, которые реально нужны продукту, инлайном — без сетевого запроса и
 * без мерцания при загрузке шрифта.
 *
 * Эмодзи в интерфейсе не используются вовсе: они приносят чужую цветовую
 * палитру и рендерятся по-разному в каждой ОС.
 */
import type { SVGProps } from 'react';

const PATHS = {
  /* навигация покупателя */
  flame:
    'M8 14.5c2.5 0 4.5-1.9 4.5-4.3 0-3.4-3.2-4.6-3.2-7.7 0-.5-.6-.8-1-.5C6.6 3.2 5 5.2 5 7.6c0 .9.3 1.6.7 2.2.2.3-.1.7-.4.5-.6-.4-1-1-1.2-1.7-.1-.3-.5-.4-.7-.1-.5.7-.9 1.6-.9 2.6 0 2 1.7 3.4 4 3.4Z',
  ticket:
    'M2 6.2V4.5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1.7a1.8 1.8 0 0 0 0 3.6v1.7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9.8a1.8 1.8 0 0 0 0-3.6Z|M6 3.5v9',
  scan: 'M2 5.5v-2a1 1 0 0 1 1-1h2|M11 2.5h2a1 1 0 0 1 1 1v2|M14 10.5v2a1 1 0 0 1-1 1h-2|M5 13.5H3a1 1 0 0 1-1-1v-2|M2.5 8h11',
  coins:
    'M10.5 5.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z|M8.3 2.1a4 4 0 0 1 1.6 7.6|M5.5 9.6v1.4a4 4 0 0 0 8 0V8',
  user: 'M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z|M2.8 14a5.3 5.3 0 0 1 10.4 0',
  bell: 'M12 6.3A4 4 0 0 0 4 6.3c0 2.6-.8 3.6-1.3 4.1-.3.3-.1.8.3.8h10c.4 0 .6-.5.3-.8-.5-.5-1.3-1.5-1.3-4.1Z|M6.3 11.2a1.8 1.8 0 0 0 3.4 0',

  /* навигация кабинета */
  dashboard: 'M2.5 2.5h4.2v5.2H2.5z|M9.3 2.5h4.2v3.2H9.3z|M9.3 8.3h4.2v5.2H9.3z|M2.5 10.3h4.2v3.2H2.5z',
  list: 'M5.5 4h8.5|M5.5 8h8.5|M5.5 12h8.5|M2.5 4h.01|M2.5 8h.01|M2.5 12h.01',
  gift: 'M2.5 7.5h11v5.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z|M2 5h12v2.5H2z|M8 5v9|M8 5S7.2 2 5.6 2a1.5 1.5 0 0 0 0 3|M8 5s.8-3 2.4-3a1.5 1.5 0 0 1 0 3',
  building:
    'M3.5 14V3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v11|M9.5 6.5h2.5a.5.5 0 0 1 .5.5V14|M2 14h12|M5.5 5h2|M5.5 8h2|M5.5 11h2',
  scroll:
    'M4 2.5h8a1 1 0 0 1 1 1V13a.5.5 0 0 1-.5.5H4a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1Z|M5.5 5.5h5|M5.5 8h5|M5.5 10.5h3',
  plus: 'M8 3.5v9|M3.5 8h9',

  /* честность и проверка */
  shield: 'M8 14s4.5-2 4.5-6V4L8 2.2 3.5 4v4c0 4 4.5 6 4.5 6Z|M6.2 8.1 7.4 9.4 10 6.6',
  hash: 'M6 2.5 5 13.5|M11 2.5 10 13.5|M3 5.8h10.2|M2.8 10.2H13',
  key: 'M9.8 6.2a2.3 2.3 0 1 1 3.2 3.2l-.8-.8-1 1 .8.8L10.6 12l-.9-.9-1 1 .9.9-1.2 1.2a2.3 2.3 0 0 1-3.2-3.2Z',
  check: 'M3.5 8.5 6.5 11.5 12.5 4.5',
  checkCircle: 'M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z|M5.8 8.2 7.3 9.7 10.4 6.4',
  alert: 'M8 2.6 14 13H2L8 2.6Z|M8 6.5v3|M8 11.4h.01',
  info: 'M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z|M8 7.3v3.6|M8 5.2h.01',
  menu: 'M2.5 4h11|M2.5 8h11|M2.5 12h11',
  close: 'M4 4l8 8|M12 4l-8 8',

  /* время и даты */
  calendar: 'M3 4.5h10a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5Z|M5.5 2.5v3|M10.5 2.5v3|M2.5 7.5h11',
  clock: 'M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z|M8 5v3.2l2.2 1.3',

  /* действия */
  chevronLeft: 'M10 4 6 8l4 4',
  chevronRight: 'M6 4l4 4-4 4',
  chevronDown: 'M4 6l4 4 4-4',
  arrowLeft: 'M12.5 8h-9|M7 3.5 3.5 8 7 12.5',
  arrowRight: 'M3.5 8h9|M9 3.5 12.5 8 9 12.5',
  external: 'M9.5 3h3.5v3.5|M13 3 8 8|M11.5 9.8V12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5.5a1 1 0 0 1 1-1h2.2',
  download: 'M8 2.8v7.4|M5 7.5 8 10.5l3-3|M3 13h10',
  upload: 'M8 10.5V3|M5 6 8 3l3 3|M3 13h10',
  copy: 'M5.5 5.5h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1Z|M11 4V2.5a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1V10',
  refresh: 'M13 7.5a5 5 0 1 0-1.5 4.6|M13 3.5v4h-4',
  search: 'M11.5 7.2a4.3 4.3 0 1 1-8.6 0 4.3 4.3 0 0 1 8.6 0Z|M10.6 10.6 13.8 13.8',
  settings:
    'M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z|M12.9 10a1.1 1.1 0 0 0 .2 1.2l.1.1a1.2 1.2 0 1 1-1.7 1.7l-.1-.1a1.1 1.1 0 0 0-1.9.8v.2a1.2 1.2 0 1 1-2.4 0v-.1a1.1 1.1 0 0 0-1.9-.8l-.1.1a1.2 1.2 0 1 1-1.7-1.7l.1-.1a1.1 1.1 0 0 0-.8-1.9h-.2a1.2 1.2 0 1 1 0-2.4h.1a1.1 1.1 0 0 0 .8-1.9l-.1-.1a1.2 1.2 0 1 1 1.7-1.7l.1.1a1.1 1.1 0 0 0 1.9-.8V2.5a1.2 1.2 0 1 1 2.4 0v.1a1.1 1.1 0 0 0 1.9.8l.1-.1a1.2 1.2 0 1 1 1.7 1.7l-.1.1a1.1 1.1 0 0 0 .8 1.9h.2a1.2 1.2 0 1 1 0 2.4h-.1a1.1 1.1 0 0 0-1 .6Z',

  /* результаты */
  trophy: 'M5 2.5h6v3.8a3 3 0 0 1-6 0Z|M5 3.8H3.3a.5.5 0 0 0-.5.6c.2 1.2.9 2.1 2.2 2.3|M11 3.8h1.7a.5.5 0 0 1 .5.6c-.2 1.2-.9 2.1-2.2 2.3|M8 9.3v2.4|M5.8 13.5h4.4|M6.5 11.7h3l.7 1.8h-4.4z',
  wheel:
    'M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z|M9.2 8a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z|M8 2v4.8|M8 9.2V14|M2 8h4.8|M9.2 8H14',
  chart: 'M2.5 13.5h11|M5 11V7|M8 11V3.5|M11 11V8.5',
  eye: 'M8 3.5c3 0 5.3 2.2 6 4.5-.7 2.3-3 4.5-6 4.5S2.7 10.3 2 8c.7-2.3 3-4.5 6-4.5Z|M9.8 8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z',
  sparkle: 'M8 2.2 9.3 6.1 13.2 7.4 9.3 8.7 8 12.6 6.7 8.7 2.8 7.4 6.7 6.1 8 2.2Z|M12.6 11.2l.5 1.4 1.4.5-1.4.5-.5 1.4-.5-1.4-1.4-.5 1.4-.5.5-1.4Z',
  star: 'M8 2.4l1.8 3.7 4 .6-2.9 2.8.7 4L8 11.6l-3.6 1.9.7-4L2.2 6.7l4-.6L8 2.4Z',
  moon: 'M13 9.3A5.5 5.5 0 0 1 6.7 3a5.5 5.5 0 1 0 6.3 6.3Z',
  sun: 'M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z|M8 1.8v1.4|M8 12.8v1.4|M1.8 8h1.4|M12.8 8h1.4|M3.6 3.6l1 1|M11.4 11.4l1 1|M12.4 3.6l-1 1|M4.6 11.4l-1 1',
  logout: 'M6 14H3.5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1H6|M10.5 11 13.5 8l-3-3|M13.5 8H6',
  /* сферы: верхний уровень навигации в ленте покупателя */
  cart: 'M2 2.5h1.8l1.9 7.6h6.2l1.6-5.4H4.4|M6.8 13a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z|M11.9 13a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z',
  bottle: 'M6.5 1.8h3v2.1c0 .7.3 1.3.8 1.8l.4.4c.5.5.8 1.1.8 1.8v5.4a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1V7.9c0-.7.3-1.3.8-1.8l.4-.4c.5-.5.8-1.1.8-1.8V1.8Z|M4.5 9.5h7',
  bowl: 'M2.2 7.5h11.6a5.8 5.8 0 0 1-5.8 5.3 5.8 5.8 0 0 1-5.8-5.3Z|M6 5.2c0-.8.8-1 .8-1.8S6 2.2 6 2.2|M9.4 5.2c0-.8.8-1 .8-1.8s-.8-1.2-.8-1.2',
  cup: 'M3 4.5h8v5a3.5 3.5 0 0 1-7 0v-5Z|M11 5.8h1.3a1.6 1.6 0 0 1 0 3.2H11|M3 13.5h8',
  pill: 'M9.6 2.9a3.4 3.4 0 0 1 4.8 4.8l-6 6a3.4 3.4 0 0 1-4.8-4.8l6-6Z|M6.3 6.2l3.5 3.5',
  device: 'M2.5 3.5h11v7h-11z|M5.5 13.5h5|M8 10.5v3',
  drop: 'M8 2.2c2.4 2.6 3.8 4.5 3.8 6.3a3.8 3.8 0 0 1-7.6 0c0-1.8 1.4-3.7 3.8-6.3Z',
  shirt: 'M6 2.2 3 3.8 2 6.4l2 .9v6.2h8V7.3l2-.9-1-2.6-3-1.6|M6 2.2a2 2 0 0 0 4 0',
  fuel: 'M3 13.5V3.2a1 1 0 0 1 1-1h4.6a1 1 0 0 1 1 1v10.3|M2 13.5h8.6|M4.6 5h3.4v2.6H4.6z|M9.6 6.5h1.8a1 1 0 0 1 1 1v3.3a1 1 0 0 0 2 0V7.4L12.6 5.6',
  signal: 'M13 13.5V2.5|M9.7 13.5V6|M6.4 13.5V8.6|M3.1 13.5v-2.6',

  /* сферы: недвижимость, онлайн- и офлайн-сервисы, ставки. Эти четыре
     категории ссылались на иконки, которых в наборе не было, и рисовались
     пустым местом. */
  house: 'M2.5 7.2 8 2.8l5.5 4.4V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V7.2Z|M6.5 13.5V9.3h3v4.2',
  cloud: 'M4.6 12.5a2.9 2.9 0 0 1-.3-5.8 3.6 3.6 0 0 1 6.9-.6 2.7 2.7 0 0 1-.4 5.4z',
  wrench: 'M9.9 2.6a3.4 3.4 0 0 0-3.3 5.6L2.9 11.9a1.2 1.2 0 0 0 1.7 1.7l3.7-3.7a3.4 3.4 0 0 0 4.3-4.6l-1.9 1.9-1.6-.4-.4-1.6 1.9-1.9a3.4 3.4 0 0 0-.7-.7Z',
  dice: 'M2.5 4.2a1.7 1.7 0 0 1 1.7-1.7h7.6a1.7 1.7 0 0 1 1.7 1.7v7.6a1.7 1.7 0 0 1-1.7 1.7H4.2a1.7 1.7 0 0 1-1.7-1.7z|M5.6 5.6h.01|M10.4 5.6h.01|M8 8h.01|M5.6 10.4h.01|M10.4 10.4h.01',
  /* сферы: туризм и авиакомпании. */
  map: 'M1.8 4.3 6 2.7v9.2l-4.2 1.6V4.3Z|M6 2.7l4 1.6v9.2L6 11.9|M10 4.3l4.2-1.6v9.2L10 13.5',
  plane: 'M14 2 2 7.4l4.3 1.7M14 2 8.9 14l-2.6-4.9M14 2 6.3 9.1',
  qr: 'M2.5 2.5h4v4h-4z|M9.5 2.5h4v4h-4z|M2.5 9.5h4v4h-4z|M9.5 9.5v1.5|M12 9.5v1.5|M9.5 12.5h1.5|M12.5 12.5h1|M13.5 11h-.5',
  // Отправка: стрелка вверх, как в строке ввода. Самолётик здесь читается
  // как «письмо», а человек не письмо шлёт — он начинает разговор.
  arrowUp: 'M8 13V3.5|M3.8 7.7 8 3.5l4.2 4.2',
  chevron: 'M4.2 6.4 8 10.2l3.8-3.8',
} as const;

export type IconName = keyof typeof PATHS;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  /** Размер в пикселях. 16 — базовый, как у Linear. */
  size?: number;
}

export function Icon({ name, size = 16, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {PATHS[name].split('|').map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}

/**
 * Кружок-индикатор статуса. У Linear состояние задачи — это маленькое кольцо с
 * заполнением по прогрессу; тот же приём здесь показывает ход акции.
 *
 * progress: 0 — ничего не закрашено, 1 — круг закрашен полностью.
 */
export function StatusRing({
  progress,
  size = 14,
  tone = 'currentColor',
}: {
  progress: number;
  size?: number;
  tone?: string;
}) {
  const clamped = Math.max(0, Math.min(1, progress));
  const r = 5;
  const circumference = 2 * Math.PI * r;

  return (
    <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true" focusable="false">
      <circle cx="7" cy="7" r={r} fill="none" stroke={tone} strokeWidth="1.5" opacity="0.3" />
      {clamped > 0 && (
        <circle
          cx="7"
          cy="7"
          r={r}
          fill="none"
          stroke={tone}
          strokeWidth="3"
          strokeDasharray={`${circumference * clamped} ${circumference}`}
          /* Обводка шириной 3 поверх радиуса 5 даёт эффект «долитого» круга;
             поворот на −90° начинает заливку сверху, а не справа. */
          transform="rotate(-90 7 7)"
          opacity="0.9"
        />
      )}
      {clamped >= 1 && <circle cx="7" cy="7" r="2.5" fill={tone} />}
    </svg>
  );
}
